/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scopeTree.vue?vue&type=template&id=70686b7b&scoped=true"
import script from "./scopeTree.vue?vue&type=script&lang=js"
export * from "./scopeTree.vue?vue&type=script&lang=js"
import style0 from "./scopeTree.vue?vue&type=style&index=0&id=70686b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70686b7b",
  null
  
)

export default component.exports